<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          System Level Categories
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New Category</vs-button>
        </h3>
        <p class="card-subtitle">List of Default Categories to System.</p>
        <vs-row>
          <!-- <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Language Filter" v-model="search.language">
              <vs-select-item value="all" text="All Languages" />
              <vs-select-item :key="index" :value="item.culture" :text="item.culture"
                v-for="(item, index) in languages" />
            </vs-select>
          </vs-col> -->
          <div style="display: flex; align-items: center; gap: 0.5rem">
            <vs-select :color="colorx" label="Sorting Type" v-model="search.sort" @change="searchData()">
              <vs-select-item value text="Select Sorting" disabled />
              <vs-select-item value="ASC" text="Ascending" />
              <vs-select-item value="DESC" text="Descending" />
            </vs-select>

            <vs-select :color="colorx" label="Language Filter" v-model="search.language" @change="searchData">
              <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
            </vs-select>

            <vs-select :color="colorx" label="Status Filter" v-model="search.status" @change="searchData()">
              <vs-select-item value text="Select Status" disabled />
              <vs-select-item value="0" text="All" />
              <vs-select-item value="1" text="Active" />
              <vs-select-item value="2" text="Inactive" />
            </vs-select>

            <vs-select :color="colorx" label="Page Limit" v-model="limit" @change="searchData()">
              <vs-select-item value="25" text="25" />
              <vs-select-item value="50" text="50" />
              <vs-select-item value="100" text="100" />
            </vs-select>
            <!-- <vs-button color="primary" type="filled" class="searchBtn" @click="searchData()"
              icon="search">Search</vs-button> -->
            <vs-button color="warning" type="filled" class="searchBtn" icon="cached" @click="resetData()" style="width: 12%">Reset</vs-button>
            <vs-button color="success" type="filled" class="searchBtn" icon="sort" @click="sortPositions()" style="width: 12%">Sort</vs-button>
          </div>
        </vs-row>

        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <th></th>
            <th>Category Name</th>
            <th @click="sortBy('position')" style="cursor: pointer; text-align: center">
              Position
              <span v-if="sortByField === 'position'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th class="text-center">Language</th>
            <th @click="sortBy('status')" style="cursor: pointer">
              Status
              <span v-if="sortByField === 'status'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th class="text-center" @click="sortBy('totalShares')" style="cursor: pointer">
              Total Shares
              <span v-if="sortByField === 'totalShares'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item._id">
            <td>{{ index + 1 + (currentPage - 1) * limit }}</td>
            <td>
              <img v-if="item.image == '' || item.image == null" src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="item.image" height="50px" width="75px" />
            </td>
            <td class="td">{{ item.name }}</td>
            <td class="td">
              <!-- add up and down arrows from react-icons -->
              <div style="display: flex; align-items: center; flex-direction: column; justify-content: center; gap: 0.5rem">
                <vs-button icon="arrow_upward" size="small" @click="updatePosition(item._id, search.sort === 'ASC' ? 'up' : 'down')"></vs-button>
                {{ item.position }}
                <vs-button icon="arrow_downward" size="small" @click="updatePosition(item._id, search.sort === 'ASC' ? 'down' : 'up')"></vs-button>
              </div>
            </td>
            <td class="td text-center">
              {{ item.language }}
              <div class="d-flex" v-if="search.language == 'EN' && item.languageCount">
                <div class="progress-bar-container mt-3">
                  <div
                    class="progress-bar p-2"
                    :style="{
                      color: item.languageCount - item.missingLanguages.length === item.languageCount ? 'white' : 'black',
                      backgroundColor: item.missingLanguages.length > 0 ? 'red' : item.missingLanguages.length > 1 ? '#06b800' : '',
                      width: ((item.languageCount - item.missingLanguages.length) / item.languageCount) * 100 + '%',
                    }"
                  >
                    <div class="absoluteText">{{ item.languageCount - item.missingLanguages.length }}/{{ item.languageCount }}</div>
                  </div>
                </div>
                <div class="text-center mt-2 d-flex align-items-center" style="font-weight: 800">
                  <div style="width: 20px; height: 20px; margin-left: 5px" v-popover:tooltip="item.tooltipContent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12" y2="8"></line>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
            <td class="td">
              <vs-chip v-if="item.status" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>
            <td class="td d-flex align-items-center justify-content-center">
              <vs-button style="width: 60px" color="primary" type="filled" class="searchBtn"> {{ item.totalShares }}</vs-button>
            </td>
            <td class="td">
              <vs-button class="mr15 mt-1" icon="create" size="small" color="warning" @click="editingItem(item, 'edit')">Edit</vs-button>
              <vs-button
                class="mr15 mt-1"
                size="small"
                color="danger"
                icon="delete_sweep"
                @click="
                  deleteCategoryPopup = true;
                  itemToDelete = item;
                "
              >
                Delete
              </vs-button>
              <vs-button class="mr15 mt-1" size="small" color="primary" icon="visibility" @click="viewAllPosts(item)"> View All Posts </vs-button>
              <vs-button class="mr15 mt-1" size="small" color="primary" icon="content_copy" @click="copyGuid(item.guid)"> Copy </vs-button>
              <!-- <vs-button class="mr15 mt-1" size="small" color="success"
                @click="editingItem(item, 'clone')">Duplicate</vs-button> -->
            </td>
          </tr>
        </table>
        <!-- pagination -->
        <vs-pagination v-model="currentPage" :total="totalPages" :limit="limit" @change="searchData" class="my-4" />

        <!-- Code -->
        <vs-popup :title="isNew ? 'Add New Category' : clone ? 'Duplicate Category' : 'Edit Category'" :active.sync="defaultalert">
          <vs-row>
            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; padding-left: 1rem; padding-right: 1rem">
              <vs-select
                :color="colorx"
                label="Category Language"
                @change="fileterusingLanguage($event, cat)"
                v-model="cat.language"
                icon="arrow_downward"
                :disabled="isNew == true || clone == true"
                class="mb-3"
              >
                <vs-select-item value text="Choose Language" disabled />
                <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages" :key="index" />
              </vs-select>
              <div style="display: flex; align-items: center; gap: 0.5rem" v-if="!isNew">
                <vs-button size="small" color="primary" icon="content_copy" @click="copyGuid(cat.guid)"> Copy </vs-button>
                <!-- <vs-button
                  size="small"
                  color="danger"
                  icon="delete_forever"
                  @click="
                    deleteCategoryPopup = true;
                    itemToDelete = cat;
                  "
                >
                  Delete
                </vs-button> -->
              </div>
            </div>

            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Category Name (Keep it Simple and short)" v-model="cat.name" />
            </vs-col>
            <!-- <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="Category Position (Try to assign different position)"
                v-model="cat.position" />
            </vs-col>  -->
            <!-- two check marks, move to bottom move to up -->
            <vs-col vs-lg="12" vs-xs="12">
              <p class="mt-2" style="font-size: 0.85rem">{{ isNew ? "Choose Position" : "Change Position" + cat.position }}</p>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="">
              <vs-checkbox v-model="cat.moveTop" @change="cat.moveBottom = false">Move to Top</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="">
              <vs-checkbox v-model="cat.moveBottom" @change="cat.moveTop = false">Move to Bottom</vs-checkbox>
            </vs-col>

            <vs-col vs-lg="10" vs-xs="6" class="mt-5">
              <vs-checkbox v-model="cat.status">Status (Active / Inactive)</vs-checkbox>
            </vs-col>

            <div class="mt-4" style="padding-left: 1rem; padding-right: 1rem" v-if="isNew">
              <p>Choose Languages to Translate</p>
              <div style="display: flex; flex-wrap: wrap; gap: 0.5rem">
                <vs-checkbox v-model="selectAll" @change="toggleSelectAll">All</vs-checkbox>
                <div v-for="lang in languages" :key="lang.culture">
                  <vs-checkbox
                    :value="cat.languagesToTranslate.includes(lang.culture)"
                    :disabled="lang.culture === 'EN'"
                    @change="toggleLanguage(lang.culture)"
                  >
                    {{ lang.culture }}
                  </vs-checkbox>
                </div>
              </div>
            </div>
            <div
              class="mt-4"
              style="padding-left: 1rem; padding-right: 1rem"
              v-if="!isNew && cat.language == 'EN' && cat.missingLanguages.length > 0"
            >
              <div class="mb-4" style="display: flex; align-items: center">
                <vs-checkbox v-model="cat.translateMissing">Add missing translations</vs-checkbox>
              </div>
              <div style="display: flex; flex-wrap: wrap; gap: 0.5rem" v-if="cat.translateMissing">
                <vs-checkbox v-model="selectAllEdit" @change="toggleSelectAllEdit">All</vs-checkbox>
                <div v-for="lang in cat.missingLanguages" :key="lang">
                  <vs-checkbox
                    :value="cat.languagesToTranslate.includes(lang) && lang !== 'EN'"
                    :disabled="lang.culture === 'EN'"
                    @change="toggleLanguage(lang.culture)"
                  >
                    {{ lang }}
                  </vs-checkbox>
                </div>
              </div>
            </div>

            <!-- <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <uploader
                label="Category File (Try to use square image)"
                v-model="cat.image"
                :file="cat.image"
              />
            </vs-col> -->
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="!displayImage">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Category File (Try to use square image)</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage()"></vs-button>
                  <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                  <b v-if="fileName">File Name : {{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="11" vs-xs="12">
              <vs-button icon="save" v-if="isNew" @click="cat.languagesToTranslate.length > 1 ? createAndTranslate() : btnAddCategory()">{{
                cat.languagesToTranslate.length > 1 ? "Save and Translate" : "Save English"
              }}</vs-button>
              <!-- show only if language is english -->
              <vs-button icon="save" class="ml-3" @click="btnAddCategory" v-if="!isNew">Update one</vs-button>
              <vs-button icon="save" class="ml-3" @click="updateAndTranslate" v-if="!isNew && !showLoader && cat.language == 'EN'"
                >Update all</vs-button
              >
              <vs-checkbox v-model="cat.translate" v-if="!isNew && cat.language == 'EN'" class="mt-2">Update existing translations</vs-checkbox>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete Category" :active.sync="deleteCategoryPopup" style="z-index: 999999999">
          <p>Are you sure you want to delete Category?</p>
          <div>
            <vs-button icon="delete_forever" class="mr15" @click="deleteCategory">Delete Category</vs-button>
            <vs-button icon="clear" @click="deleteCategoryPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
    <div v-if="showLoader" class="loader-container">
      <!-- show text that it is working in background. -->
      <div class="loader"></div>
      <vs-col vs-lg="12" vs-xs="1">
        <p class="loader-text">Translations are in progress.</p>
      </vs-col>
    </div>
    <tooltip :width="300" :pointer="true"> </tooltip>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import { API } from "@/common/constants";
import Vue from "vue";
import VPopover from "vue-js-popover";
import Multiselect from "vue-multiselect";

Vue.use(VPopover, { tooltip: true });

// import OhVueIcon from "oh-vue-icons";

export default {
  name: "Category",
  components: {
    // "v-icon": OhVueIcon,
    // uploader,
    Multiselect,
  },
  data: () => ({
    title: "Category",
    colorx: "#0D2144",
    defaultalert: false,
    deleteCategoryPopup: false,
    disableCategoryPopup: false,
    isNew: true,
    clone: false,
    displayImage: "",
    fileName: "",
    sortByField: "asc",
    sortDirection: "",
    search: {
      sort: "ASC",
      language: "EN",
      status: "0",
    },
    selectAll: false,
    selectAllEdit: false,
    limit: 25,
    currentPage: 1,
    totalPages: 0,
    cat: {
      missingLanguages: [],
      languagesToTranslate: ["EN"],
      status: true,
      language: "",
      position: "",
      name: "",
      image: "",
      moveTop: false,
      moveBottom: false,
      translate: false,
      translateMissing: false,
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
    showLoader: false,
  }),
  computed: {
    sortedData() {
      if (this.sortByField) {
        return this.all.sort((a, b) => {
          if (this.sortDirection === "asc") {
            return a[this.sortByField] > b[this.sortByField] ? 1 : -1;
          } else {
            return a[this.sortByField] < b[this.sortByField] ? 1 : -1;
          }
        });
      }
      return this.all;
    },
  },
  watch: {
    "search.language": function (newLang, oldLang) {
      if (newLang !== oldLang) {
        this.currentPage = 1;
      }
    },
    "search.sort": function (newSort, oldSort) {
      if (newSort !== oldSort) {
        this.currentPage = 1;
      }
    },
    "search.status": function (newStatus, oldStatus) {
      if (newStatus !== oldStatus) {
        this.currentPage = 1;
      }
    },
    limit: function (newLimit, oldLimit) {
      if (newLimit !== oldLimit) {
        this.currentPage = 1;
      }
    },
  },
  methods: {
    toggleSelectAll() {
      if (this.selectAll) {
        this.cat.languagesToTranslate = this.languages.map((lang) => lang.culture);
      } else {
        this.cat.languagesToTranslate = ["EN"];
      }
    },

    toggleSelectAllEdit() {
      if (this.selectAllEdit) {
        this.cat.languagesToTranslate = this.cat.missingLanguages;
      } else {
        this.cat.languagesToTranslate = ["EN"];
      }
    },

    toggleLanguage(culture) {
      const selectedLanguages = this.cat.languagesToTranslate;

      if (selectedLanguages.includes(culture)) {
        this.cat.languagesToTranslate = selectedLanguages.filter((lang) => lang !== culture);
      } else {
        this.cat.languagesToTranslate = [...selectedLanguages, culture];
      }

      const allLanguagesSelected = this.languages.every((lang) => this.cat.languagesToTranslate.includes(lang.culture));
      this.selectAll = allLanguagesSelected;
      if (this.selectAllEdit) {
        const allLanguagesSelected = this.cat.missingLanguages.every((lang) => this.cat.languagesToTranslate.includes(lang));
        this.selectAllEdit = allLanguagesSelected;
      }
    },

    sortBy(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortByField = field;
        this.sortDirection = "asc";
      }
      this.all = this.sortedData;
    },
    sortPositions() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      api
        .put(`${API.SORT_POSITION}?language=${this.$data.search.language}`, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              text: "Sorted Successfully",
              color: "success",
              position: "top-right",
            });
            this.searchData();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            text: "Error Deleting",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
    updatePosition(id, type) {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      api
        .put(`${API.UPDATE_POSITION}/${id}?direction=${type}`, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              text: "Position Updated Successfully",
              color: "success",
              position: "top-right",
            });
            this.fetchAllCategory();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            text: e.response.data.error,
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },

    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.selectAll = false;
      this.$data.cat = {
        status: true,
        language: "EN",
        position: "",
        name: "",
        image: "",
        moveTop: false,
        moveBottom: true,
        languagesToTranslate: ["EN"],
      };
      this.$data.displayImage = "";
    },
    editingItem(i, data) {
      i.languagesToTranslate = [];
      this.$data.clone = data == "clone" ? true : false;
      this.$data.displayImage = i.image;
      this.$data.cat = Object.assign({}, i);
      this.$data.isNew = false;
      this.$data.defaultalert = true;
    },
    async btnAddCategory() {
      try {
        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };

        if (JSON.parse(localStorage.user).token) {
          headers["x-master-token"] = JSON.parse(localStorage.user).token;
        }

        if (!this.$data.cat.name || !this.$data.cat.image) {
          this.$vs.notify({
            text: "Category Name and Image is required",
            color: "danger",
            position: "top-right",
          });
          return;
        }

        this.$vs.loading();
        let apiToCall = API.INSERT_CAT;
        let data = this.$data.cat;

        if (this.$data.clone) {
          apiToCall = API.INSERT_CAT;

          data = {
            name: this.$data.cat.name,
            position: this.$data.cat.position,
            count: this.$data.cat.count,
            language: this.$data.cat.language,
            status: this.$data.cat.status,
            image: this.$data.cat.image,
            moveTop: this.$data.cat.moveTop,
            moveBottom: this.$data.cat.moveBottom,
          };
        }

        if (!this.$data.isNew) {
          apiToCall = API.UPDATE_CAT;
          data["image"] = this.$data.displayImage;

          const res = await api.put(`${apiToCall}/${this.$data.cat._id}`, data, { headers });
          if (res.status) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            this.$data.cat = {
              status: true,
              language: "EN",
              position: "",
              name: "",
              image: "",
              moveTop: false,
              moveBottom: true,
              languagesToTranslate: ["EN"],
            };
          }
        } else {
          const res = await api.post(apiToCall, data, { headers });
          if (res.status) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            this.$data.cat = {
              status: true,
              language: "EN",
              position: "",
              name: "",
              image: "",
              moveTop: false,
              moveBottom: true,
              languagesToTranslate: ["EN"],
            };
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.fetchAllCategory();
        this.$vs.loading.close();
      }
    },
    async createAndTranslate() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      if (!this.$data.cat.name || !this.$data.cat.image) {
        this.$vs.notify({
          text: "Category Name and Image is required",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let data = {
        language: this.$data.cat.language,
        name: this.$data.cat.name,
        image: this.$data.cat.image,
        position: this.$data.cat.position,
        status: this.$data.cat.status,
        moveTop: this.$data.cat.moveTop,
        moveBottom: this.$data.cat.moveBottom,
        languagesToTranslate: this.$data.cat.languagesToTranslate,
      };

      this.$data.showLoader = true;
      this.$data.defaultalert = false;

      const r = await api.post(API.C_AND_T_CAT, data, { headers });
      try {
        if (r.status === 200) {
          this.$vs.loading.close();
          this.$vs.notify({
            text: "Translation Created Successfully",
            color: "success",
            position: "top-right",
          });
          this.fetchAllCategory();
          this.$data.cat.name = r.data.name;
          this.$data.defaultalert = false;
          this.$data.showLoader = false;
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error Deleting",
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
        this.$data.showLoader = false;
        throw error;
      }
    },
    async updateAndTranslate() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      let data = {
        language: this.$data.cat.language,
        name: this.$data.cat.name,
        image: this.$data.cat.image,
        position: this.$data.cat.position,
        status: this.$data.cat.status,
        moveTop: this.$data.cat.moveTop,
        moveBottom: this.$data.cat.moveBottom,
        translate: this.$data.cat.translate,
        languagesToTranslate: this.$data.cat.languagesToTranslate,
      };

      this.$data.showLoader = true;
      this.$data.defaultalert = false;

      const r = await api.put(`${API.U_AND_T_CAT}/${this.$data.cat._id}`, data, { headers });
      try {
        if (r.status === 200) {
          this.$vs.loading.close();
          this.$vs.notify({
            text: "Translation Updated Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.cat.name = r.data.name;
          this.$data.showLoader = false;
          this.fetchAllCategory();
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error saving",
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
        this.$data.defaultalert = false;
        throw error;
      }
    },

    async fetchAllCategory() {
      this.$vs.loading();
      // console.log(this.$data.search.language)

      const res = await api.get(
        `${API.GET_CAT}?language=${this.$data.search.language}&sort=${this.$data.search.sort}&status=${this.$data.search.status}`
      );
      try {
        this.$vs.loading.close();
        for (const item of res.data.data) {
          item.tooltipContent =
            item.missingLanguages.length > 0 ? "Missing Languages: " + item.missingLanguages.join(", ") : "All Languages are translated";
        }

        this.$data.all = res.data.data;

        if (!res.status === 200) {
          this.$vs.notify({
            title: "Error",
            text: res.data.error,
            color: "danger",
            position: "top-right",
          });
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error Deleting",
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
        throw error;
      }
    },
    deleteCategory() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(`${API.DELETE_CAT}/${this.$data.itemToDelete._id}`, { headers })
        .then((r) => {
          if (r.status === 200) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deleteCategoryPopup = false;
          if (this.$data.defaultalert) {
            this.$data.defaultalert = false;
          }
          this.fetchAllCategory();
        })
        .catch(() => {
          this.$vs.notify({
            text: "Error Deleting",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
          console.log(this.$data.languages);
        })
        .catch(() => {
          this.$vs.notify({
            text: "Error Deleting",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
    async searchData() {
      // if (this.$data.search.language == "all") {
      //   this.fetchAllCategory();
      //   return;
      // }
      this.$vs.loading();
      try {
        const page = !isNaN(this.currentPage) && this.currentPage > 0 ? this.currentPage : 1;

        const res = await api.get(
          `${API.GET_CAT}?language=${this.$data.search.language}&sort=${this.$data.search.sort}&status=${this.$data.search.status}&page=${page}&limit=${this.limit}`
        );
        if (res.status) {
          this.$data.all = res.data.data;
          this.totalPages = Math.ceil(res.data.totalNumber / this.limit);
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error Deleting",
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },
    fileterusingLanguage(event, item) {
      let id = item.ref || item._id;
      if (event && id) {
        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };
        if (JSON.parse(localStorage.user).token) {
          headers["token"] = this.$data.token;
        }
        this.$vs.loading();
        api
          .get(`${API.GET_CAT_SINGLE}/${id}?language=${event}`, { headers })
          .then((r) => {
            const missingLanguages = this.$data.all.find((i) => i._id === id).missingLanguages;
            r.data.missingLanguages = missingLanguages;
            r.data.languagesToTranslate = [];
            this.$data.cat = Object.assign({}, r.data);
            this.$data.displayImage = r.data.image;
            this.fetchAllCategory();
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
    uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("category", this.$data.cat.name);
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            this.$data.displayImage = response.data.files[0].url;
            this.$data.cat.image = response.data.files[0].url;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    deleteImage() {
      this.$data.displayImage = "";
    },
    resetData() {
      this.$data.search = {
        sort: "ASC",
        language: "EN",
        status: "1",
      };
      this.$data.limit = 25;
      this.$data.sortByField = "";
      this.searchData();
    },
    viewAllPosts(i) {
      this.$router.push("/post/?category=" + i._id + "&catLang=" + i.language);
    },
    copyGuid(guid) {
      var input_temp = document.createElement("input");
      input_temp.value = guid;
      document.body.appendChild(input_temp);
      input_temp.select();
      document.execCommand("copy");
      document.body.removeChild(input_temp);
      this.$vs.notify({
        text: "GUID copied",
        color: "success",
        position: "top-right",
      });
    },
  },
  created() {
    // if (this.$data.search.language) {
    //   this.$data.search.language = this.$route.query.catLang;
    // }
    this.$route.query.catLang ? this.searchData() : this.fetchAllCategory();
    this.fetchAllLanguages();
    if (!this.$data.search.language) {
      this.$data.search.language = "EN";
    }
  },
};
</script>
<style scoped>
.loader-container {
  background-color: gray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-left: 1rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.loader {
  border: 2px solid white;
  border-top: 2px solid red;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: white;
  text-align: center;
  font-size: 1.2rem;
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px rgba(0, 0, 0, 0.068) solid;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-bar {
  height: 10px;
  transition: width 0.3s ease;
}

.absoluteText {
  text-align: start;
}
</style>
